import { render, staticRenderFns } from "./ComparisonButton.vue?vue&type=template&id=779118e8&scoped=true"
import script from "./ComparisonButton.vue?vue&type=script&lang=js"
export * from "./ComparisonButton.vue?vue&type=script&lang=js"
import style0 from "./ComparisonButton.vue?vue&type=style&index=0&id=779118e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779118e8",
  null
  
)

export default component.exports